import { ComponentProps } from "react";
import { ReadOnlyField } from "@dbn/omnichannel-design-system-g4p";
import { useFormatMoneyAmountValue } from "../../intl";
import { constant, pipe } from "fp-ts/function";
import { option } from "fp-ts";
import { MoneyField } from "../Price/MoneyField/MoneyField";
import { ReadOnlyFieldToValue } from "../ReadOnlyField/ReadOnlyFieldToValue";

type Feedback = ComponentProps<typeof ReadOnlyField>["feedback"];

type Props = ComponentProps<typeof MoneyField> & {
  edit: boolean;
  feedback?: Feedback;
};

export function OptionalEditMoneyField(props: Props) {
  const formatMoneyAmountValue = useFormatMoneyAmountValue();
  const { edit, ...fieldProps } = props;

  return edit ? (
    <MoneyField {...fieldProps} />
  ) : (
    <ReadOnlyFieldToValue
      size="medium"
      label={props.label}
      value={formatMoneyAmountValue(
        pipe(props.value, option.getOrElse(constant(0)), amount => ({
          amount,
          currency: props.currency,
        }))
      )}
      feedback={props.feedback}
    />
  );
}
